import React from 'react';
import type { BugReportStatus } from '../types/types';

interface StatusBadgeProps {
  status: BugReportStatus;
}

const STATUS_CONFIG: Record<BugReportStatus, { label: string; className: string }> = {
  open: {
    label: 'Open',
    className: 'bg-gray-100 text-gray-700',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-blue-100 text-blue-700',
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-green-100 text-green-700',
  },
  closed: {
    label: 'Closed',
    className: 'bg-slate-100 text-slate-500',
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.open;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};

export { StatusBadge };
